<form [formGroup]="formulario" class="form">

  <h2>Alterar senha</h2>
  <p>Para mudar sua senha, digite a senha atual e em seguida a nova senha.</p>
  <div class="row my-4">
    <div class="col">
      <label for="senhaAntiga" class="password-label">
        <span>Senha atual:</span>
      </label>
      <input formControlName="senhaAntiga" class="input form-control" type="password" name="senhaAntiga"
        placeholder="********">
    </div>
    <div class="message-error"
      *ngIf="formulario.get('senhaAntiga')?.errors?.required && formulario.get('senhaAntiga')?.dirty">
      Este campo é obrigatório.
    </div>
  </div>
  <div class="row my-4">
    <div class="col">
      <label for="senhaAtual" class="password-label">
        <span>Nova senha:</span>
      </label>
      <input formControlName="senhaAtual" class="input form-control" type="password" name="senhaAtual"
        placeholder="********">
    </div>
    <div class="message-error"
      *ngIf="formulario.get('senhaAtual')?.errors?.required && formulario.get('senhaAtual')?.dirty">
      Este campo é obrigatório.
    </div>
    <div class="message-error"
      *ngIf="formulario.get('senhaAtual')?.errors?.pattern && formulario.get('senhaAtual')?.dirty">
      Sua senha deve ter no mínimo 8 caracteres, sendo letras minusculas, maiúsculas, números e caracteres especiais.
    </div>
  </div>
  <div class="row my-4">
    <div class="col">
      <label for="senhaAtualConfirmacao" class="password-label">
        <span>Repita a nova senha:</span>
      </label>
      <input formControlName="senhaAtualConfirmacao" class="input form-control" type="password"
        name="senhaAtualConfirmacao" placeholder="********">
    </div>
    <div class="message-error" *ngIf="formulario.get('senhaAtualConfirmacao')?.errors?.required &&
      formulario.get('senhaAtualConfirmacao')?.dirty">
      Este campo é obrigatório.
    </div>
    <div class="message-error" *ngIf="formulario.hasError('senhasDiferentes') &&
      formulario.get('senhaAtual')?.dirty && formulario.get('senhaAtualConfirmacao')?.dirty">
      As senhas não conferem!
    </div>
  </div>
  <div class="row my-5">
    <div class="col">
      <div>
        <button class="form-button button-primary" (click)="prosseguir()" [disabled]="formulario.invalid">Mudar
          senha</button>
      </div>
    </div>
  </div>
</form>